import { optionTitle_messagePreview } from './MessagePreviewOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let MessagePreviewOption: LazyOption = createLazyOption(
    {
        key: 'messagePreview',
        titleStringKey: optionTitle_messagePreview,
        searchTermsStringKey: optionTitle_messagePreview,
    },
    lazyFullModule,
    m => m.default
);
export default MessagePreviewOption;
